import { createTheme } from "@mui/material/styles";
import { trTR } from "@mui/material/locale";
import { colors, darkColors, fonts, radius } from "./tokens";

/**
 * Uygulamanın MUI teması. mode "dark": mobil uygulamanın koyu teması
 * (koyu turkuaz zemin, beyaz ve soluk beyaz yazılar, açık turkuaz vurgu).
 */
export function makeMuiTheme(mode = "light") {
  const dark = mode === "dark";
  return createTheme(
    {
      palette: dark
        ? {
            mode: "dark",
            primary: {
              main: darkColors.soft,
              dark: darkColors.brand,
              light: darkColors.soft,
              contrastText: colors.textInverse,
            },
            success: { main: darkColors.success },
            warning: { main: colors.warning },
            error: { main: darkColors.danger },
            background: { default: darkColors.bg, paper: darkColors.paper },
            text: { primary: darkColors.text, secondary: darkColors.muted },
            divider: darkColors.line,
          }
        : {
            mode: "light",
            // contrastText'i açıkça veriyoruz: MUI #48A6A7 üzerinde otomatik olarak siyah
            // yazı seçiyordu (koyu zemin + siyah yazı). Dolgulu butonlarda zemini koyu
            // turkuaza çekip beyaz yazı kullanıyoruz: 6.36:1 kontrast, WCAG AA.
            primary: {
              main: colors.primary,
              dark: colors.primaryDark,
              light: colors.primaryLight,
              contrastText: colors.textInverse,
            },
            success: { main: colors.success },
            warning: { main: colors.warning },
            error: { main: colors.error },
            background: { default: colors.surfaceAlt, paper: colors.surface },
            text: { primary: colors.textPrimary, secondary: colors.textSecondary },
          },
      typography: {
        fontFamily: fonts.body,
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 600 },
        button: { textTransform: "none", fontWeight: 600 },
      },
      shape: { borderRadius: parseInt(radius.md, 10) },
      components: {
        MuiButton: {
          defaultProps: { disableElevation: true },
          styleOverrides: dark
            ? {
                root: { borderRadius: radius.md },
                containedPrimary: {
                  backgroundColor: darkColors.brand,
                  color: colors.textInverse,
                  "&:hover": { backgroundColor: colors.primaryDark },
                  "&.Mui-disabled": { backgroundColor: darkColors.chip, color: darkColors.faint },
                },
                outlinedPrimary: { borderColor: darkColors.soft, color: darkColors.soft },
                textPrimary: { color: darkColors.soft },
              }
            : {
                root: { borderRadius: radius.md },
                containedPrimary: {
                  backgroundColor: colors.primaryDark,
                  color: colors.textInverse,
                  "&:hover": { backgroundColor: "#00565C" },
                  "&.Mui-disabled": { backgroundColor: colors.border, color: colors.neutral },
                },
                outlinedPrimary: { borderColor: colors.primaryDark, color: colors.primaryDark },
                textPrimary: { color: colors.primaryDark },
              },
        },
        MuiLoadingButton: {
          styleOverrides: {
            loadingIndicator: { color: colors.textInverse },
          },
        },
        MuiTextField: {
          defaultProps: { size: "small", fullWidth: true, variant: "outlined" },
        },
        // Koyu temada kağıt yüzeyler (menü, pencere, çekmece) düz koyu kart:
        // MUI'nin koyu kipte eklediği gri parlama katmanı kapalı.
        MuiPaper: {
          styleOverrides: {
            root: dark ? { backgroundImage: "none" } : {},
          },
        },
      },
    },
    trTR
  );
}

/** Geriye dönük uyumluluk: açık tema (giriş, tanıtım sayfaları). */
export const muiTheme = makeMuiTheme("light");
